<template>
    <ElAffix class="project-affix" :offset="affixOffset" :z-index="5">
        <div class="1.5xl:block 1.5xl:w-[220px] hidden">
            <Catalog :catalogList="catalogList" :loading="loading" />
        </div>

        <TogglePinCatalog class="1.5xl:hidden top-[150px] hidden xl:fixed xl:block"
                          :class="{ '!top-[86px]': isAirProduct }">
            <Catalog :catalogList="catalogList" :loading="loading" />
        </TogglePinCatalog>
    </ElAffix>
</template>

<script setup lang="ts">
import { ElAffix } from 'element-plus';
import Catalog from './Catalog.vue';
import type { CatalogItem } from '@/types';
import { useGlobalState } from '@/composables/use-global-store';
import { computed } from 'vue';
import TogglePinCatalog from '@/components/report/TogglePinCatalog.vue';

const { isAirProduct } = useGlobalState()

defineProps<{
    catalogList: CatalogItem[];
    loading: boolean
}>()

const affixOffset = computed(() => {
    return isAirProduct.value ? 85 : 150
})

</script>

<style lang="scss">
.project-affix {
    @media screen and (min-width: 1280px) {
        width: 40px !important;
    }

    @media screen and (min-width: 1440px) {
        width: 220px !important;
    }
}
</style>
